import type { FileUrl } from 'clickim/src/common/models/step';
import type { ILocatedElement } from 'clickim/src/background/codeSnippets/getLocatedElement';

interface BlobWithName { blob: Blob; name: string }
declare function getLocatedElement(locatedElement: ILocatedElement | string): Element | null;
declare function createDropEvent(blobs: BlobWithName[]): DragEvent;

export const downloadFileAndFireDropEvent = function (locatedElement: ILocatedElement, fileUrls: FileUrl[]) {
    const element = getLocatedElement(locatedElement);

    if (!element) {
        throw new Error('element not found');
    }

    function simpleBarrier() {
        let callbackIndex = -1;
        let doneCallbacks = 0;
        const results: BlobWithName[] = [];
        const instance = {
            endWithCallback: undefined as ((blobs: BlobWithName[]) => void) | undefined,
            waitOn() {
                const curIndex = ++callbackIndex;
                return function (result: BlobWithName) {
                    if (curIndex in results) {
                        return;
                    }
                    results[curIndex] = result;
                    doneCallbacks++;
                    if (fileUrls.length === doneCallbacks) {
                        instance.endWithCallback!(results);
                    }
                };
            },
            endWith(fn: (blobs: BlobWithName[]) => void) { instance.endWithCallback = fn; },
        };
        return instance;
    }

    function getBlob(url: string, name: string, cb: (res: BlobWithName) => void) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                cb({ blob: xhr.response, name });
            } else {
                throw new Error('Failed to load blob response code is not between 200 - 300');
            }
        };
        xhr.onerror = function () {
            throw new Error('Failed to load blob');
        };
        xhr.send();
    }

    const barrier = simpleBarrier();
    fileUrls.forEach((fileUrl) => {
        getBlob(fileUrl.url, fileUrl.name, barrier.waitOn());
    });
    barrier.endWith((blobs: BlobWithName[]) => {
        const event = createDropEvent(blobs);
        element.dispatchEvent(event);
    });
};
